import { render, staticRenderFns } from "./CognitionView.vue?vue&type=template&id=403638a7"
import script from "./CognitionView.vue?vue&type=script&lang=js"
export * from "./CognitionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports